import React from 'react';
import Navbar from './components/Navbar';
import About from './components/About';
import ProductShowcase from './components/ProductShowcase';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import './App.css';

function App() {
  return (
    <div>
      <Navbar />
      <About />
      <ProductShowcase />
      <Gallery />
      <Contact />
    </div>
  );
}

export default App;
